import React from "react"

function IconSquaresGrid({ color = "currentColor", color2, fontSize, height, ...props }) {
  return (
    <svg
      fill={color}
      fuze-icon="squares-grid"
      viewBox="0 0 24 24"
      style={{ height: height || fontSize }}
      originalclass="fz-icon fz-icon-squares-grid"
      {...props}
    >
      <path
        d="M19.794 12.875c.815 0 1.479.673 1.479 1.5v5.398c0 .828-.662 1.5-1.479 1.5h-5.326c-.815 0-1.476-.671-1.476-1.498V14.37c0-.825.66-1.495 1.475-1.495h5.327zm-10.264 0a1.49 1.49 0 0 1 1.476 1.497v5.404c0 .827-.659 1.497-1.473 1.497h-5.33c-.815 0-1.476-.671-1.476-1.498V14.37c0-.825.66-1.495 1.475-1.495H9.53zm10.264 1.309h-5.327c-.07 0-.134.051-.157.126l-.009.06v5.405c0 .087.05.155.116.18l.051.009h5.326a.173.173 0 0 0 .16-.13l.01-.061v-5.398c0-.108-.082-.191-.17-.191zm-10.264 0H4.202c-.07 0-.134.051-.157.126l-.009.06v5.405c0 .087.051.155.116.18l.051.009h5.33c.069 0 .133-.051.155-.127l.009-.06v-5.405c0-.106-.08-.188-.167-.188zM19.927 2.727c.742 0 1.346.613 1.346 1.366v5.665c0 .755-.604 1.368-1.349 1.368h-5.586a1.356 1.356 0 0 1-1.346-1.365V4.093c0-.755.603-1.366 1.346-1.366h5.589zm-10.397 0c.816 0 1.476.671 1.476 1.498V9.63c0 .826-.66 1.496-1.473 1.496H4.202A1.487 1.487 0 0 1 2.727 9.63V4.225c0-.827.661-1.498 1.476-1.498H9.53zm10.397 1.31h-5.589c-.01 0-.023.009-.03.025l-.007.03v5.669c0 .023.01.04.02.05l.017.006h5.586c.012 0 .026-.01.033-.027l.007-.032V4.093c0-.034-.023-.057-.037-.057zm-10.397 0H4.203c-.07 0-.135.051-.158.127l-.009.06V9.63c0 .085.052.154.116.178l.05.009h5.33c.07 0 .134-.05.156-.126l.009-.06V4.224c0-.108-.08-.189-.167-.189z"
        fill={color}
        fillRule="evenodd"
        style={{ height: height || fontSize }}
        originalclass="__primary"
      />
    </svg>
  )
}

export default IconSquaresGrid
